import * as yup from 'yup';

import { Field, Form, Formik } from 'formik';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Link,
  Text,
  useToast,
} from '@chakra-ui/react';
import { sendMailNotification } from 'utils/api';

export default function MailForm() {
  const toast = useToast();

  async function onSubmitMail(values) {
    const { company_email, company_name } = values;

    try {
      const res = await sendMailNotification({
        companyEmail: company_email,
        companyName: company_name,
      });

      if (res.status === 200) {
        toast({
          title: 'Sweet!',
          description: 'We will contact you soon.',
          status: 'success',
          position: 'bottom-right',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: 'Ooops!',
        description: 'Something went wrong.',
        status: 'error',
        position: 'bottom-right',
        duration: 3000,
        isClosable: true,
      });
    }
  }
  return (
    <Box width="100%">
      <Text fontSize="xl" fontWeight="semibold" mb={5}>
        Request a Demo
      </Text>
      <Formik
        initialValues={{ company_email: '', company_name: '', consent: false }}
        validationSchema={yup.object({
          company_email: yup.string().required('Email is required'),
          company_name: yup.string().required('Name is required'),
          consent: yup.boolean().required(),
        })}
        onSubmit={(values, actions) => {
          onSubmitMail(values);
          actions.resetForm();
        }}
      >
        {(props) => (
          <Form>
            <Field name="company_email">
              {({ field, form }) => (
                <FormControl
                  mb={5}
                  isInvalid={
                    form.errors.company_email && form.touched.company_email
                  }
                >
                  <FormLabel>Company Email</FormLabel>
                  <Input
                    {...field}
                    type="email"
                    placeholder="name@yourcompany.com"
                  />
                  <FormErrorMessage>
                    {form.errors.company_email}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Field name="company_name">
              {({ field, form }) => (
                <FormControl
                  mb={5}
                  isInvalid={
                    form.errors.company_name && form.touched.company_name
                  }
                >
                  <FormLabel>Company Name</FormLabel>
                  <Input {...field} placeholder="Your Company" />
                  <FormErrorMessage>
                    {form.errors.company_name}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Box mb={5}>
              <Field name="consent">
                {({ field, form }) => (
                  <FormControl
                    mb={1}
                    display="flex"
                    flexDir="row"
                    alignItems="center"
                    gap="2"
                    isInvalid={form.errors.consent && form.touched.consent}
                  >
                    <FormLabel m={0}>Consent</FormLabel>
                    <Checkbox {...field} />
                  </FormControl>
                )}
              </Field>

              <Box color="gray.500" mb={5}>
                Artlabs needs the contact information you provide to us to
                contact you about our products and services. You may unsubscribe
                from these communications at any time. For information on how to
                unsubscribe, as well as our privacy practices and commitment to
                protecting your privacy, please review our{' '}
                <Link
                  color="blue"
                  isExternal
                  href="https://artlabs.ai/page/privacy-policy"
                >
                  Privacy Policy.
                </Link>
              </Box>
            </Box>

            <Button
              colorScheme="facebook"
              isLoading={props.isSubmitting}
              isDisabled={!props.isValid || !props.values.consent}
              type="submit"
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
